const possibleQueryParams = [
  'category',
  'product_link',
  'searchedQuery',
  'campaign_id',
  'campaign_status',
];

const emptyQueryParams = {
  category: null,
  product_link: null,
  searchedQuery: null,
  campaign_id: null,
};

/**
 * Retrieve query params from the search string
 * @param {string} search - The search string to parse
 * @returns {object} - An object with the query params
 */
export function getQueryParams(search) {
  const urlSearchParams = new URLSearchParams(search);
  return possibleQueryParams.reduce(
    (queryParams, param) => {
      queryParams[param] = urlSearchParams.get(param);
      return queryParams;
    },
    { ...emptyQueryParams },
  );
}

/**
 * Retrieve the pathname from the current URL
 * @returns {string} - The pathname
 */
export function getPathname() {
  return window.location.pathname;
}

/**
 * Retrieve a specific query param from the current URL
 * @param {string} queryParamName - The name of the query param to retrieve
 * @returns {string} - The value of the query param
 */
export function getQueryParam(queryParamName) {
  return new URL(window.location.href).searchParams.get(queryParamName);
}

/**
 * Higher order function used in React Router Link to attribute
 * @param {string} newQueryParams - query params that should change
 * @param {boolean} state - I don't know what this is
 * @returns {Function} - a function that can be passed to React Router Link to attribute
 */
export function updateLocationSearch(newQueryParams, state) {
  return function updateLocation(location) {
    const previousQueryParams = getQueryParams(location.search);
    const nextQueryParams = {
      ...previousQueryParams,
      ...newQueryParams,
    };
    const search = buildLocationSearch(nextQueryParams);
    return { ...location, search, state };
  };
}

/**
 * Build the search string from the query params
 * @param {object} nextQueryParams - The query params to build the search string from
 * @returns {string} - The search string
 */
export function buildLocationSearch(nextQueryParams) {
  let locationSearch = '?';

  for (const queryParam in nextQueryParams) {
    const queryParamValue = nextQueryParams[queryParam];
    if (queryParamValue !== null) {
      locationSearch += `${queryParam}=${queryParamValue}&`;
    }
  }
  return locationSearch.slice(0, locationSearch.length - 1);
}

/**
 * Remove a specific query param from the current URL
 * @param {string} queryParamToRemove - The name of the query param to remove
 * @returns {string} - The search string without the query param
 */
export function removeQueryParam(queryParamToRemove) {
  const currentQueryParams = getQueryParams(window.location.search);
  let locationSearch = '?';
  for (const queryParam in currentQueryParams) {
    if (queryParam === queryParamToRemove) {
      continue;
    }
    const queryParamValue = currentQueryParams[queryParam];
    if (queryParamValue !== null) {
      locationSearch += `${queryParam}=${queryParamValue}&`;
    }
  }
  return locationSearch.slice(0, locationSearch.length - 1);
}
